import React from 'react';
import { Tag } from 'antd';

/**
 * La categoria de un animal: un chip azul, igual en todas las pantallas que la
 * consuman.
 *
 * HOY LA USAN CUATRO: el listado de animales, el dashboard, el detalle de
 * evento y la ficha del animal.
 *
 * FALTAN MIGRAR (deuda real, todas dibujan lo mismo de otra forma):
 *   - `Ventas/VentaAnimales.jsx` (x4): `<Tag color="geekblue">`
 *   - `Cliente/ClienteDashboard.jsx`, `Ventas/TableroVentas.jsx` y
 *     `Ventas/TransitoriaRemate.jsx`: la columna "Categoria" de sus grillas,
 *     que renderiza texto pelado con `|| '—'`. Ojo que las dos ultimas son
 *     grillas densas con `ellipsis` y ancho fijo, asi que ahi hay que mirar si
 *     el chip suma o estorba.
 *
 * NO MIGRAR — en `Micrositio/AnimalPage.jsx`, el chip de categoria de la ficha
 * publica se dibuja con `<Tag color={colorPrimary}>`, o sea el COLOR DE MARCA
 * DEL PRODUCTOR. Eso no es deuda, es deliberado: cambiarlo por este componente
 * le hardcodearia azul encima del branding de la cabana en su propio
 * micrositio. Queda anotado aca para que nadie lo "ordene" sin saber.
 *
 * LAS REFERENCIAS VAN POR SIMBOLO Y NO POR NUMERO DE LINEA a proposito: un
 * numero de linea de OTRO archivo se pudre en el primer commit que lo toque, y
 * el que mas caro sale es justo el "NO MIGRAR" — si apunta al lugar
 * equivocado, alguien mira, no ve nada raro, y termina migrando el que si
 * llevaba el color de marca.
 *
 * ESTA LISTA ES UN INVENTARIO DE DEUDA, no una descripcion: esta para que el
 * proximo sepa cuanto falta Y que NO tiene que tocar. Si migras un consumidor,
 * actualizala en el mismo commit — un inventario viejo es peor que no tener
 * inventario, porque manda a alguien a hacer un viaje que ya esta hecho, o
 * peor, a romper algo que estaba bien.
 *
 * POR QUE ES UN COMPONENTE Y NO UN <Tag> COPIADO EN CADA TABLA: ya se habian
 * separado. `AnimalesList` la dibujaba con `<Tag color="blue">` y el Dashboard
 * como texto pelado, asi que el mismo dato se veia distinto segun la pantalla.
 * Nadie lo decidio: se escribio dos veces y una de las dos quedo vieja.
 *
 * El chip de color no es decoracion. En una lista larga leida en un telefono,
 * el color es lo que te deja saltar de categoria en categoria sin leer: la
 * forma se reconoce antes que la palabra.
 *
 * EL VALOR SE RESUELVE AFUERA a proposito. Cada endpoint lo manda distinto
 * —`/api/dashboard/stats` aplana `nombre_categoria`, `/api/animales` anida
 * `categoria.nom_categoria`— y eso es asunto de quien conoce ese endpoint. Lo
 * que se comparte es COMO SE VE, no de donde se saca.
 *
 * SIN CATEGORIA NO DIBUJA NADA. Ni un chip con un guion adentro —un recuadro de
 * color que anuncia "aca hay una categoria" para mostrar que no la hay es peor
 * que no dibujar nada—, ni el guion suelto: en la celda apilada de mobile la
 * categoria va sin etiqueta, asi que un guion pelado ahi no significa nada. Es
 * el mismo caso del precio, y la misma respuesta: ausencia de dato, ausencia de
 * linea.
 */
const TagCategoria = ({ valor }) => (
  valor ? <Tag color="blue">{valor}</Tag> : null
);

export default TagCategoria;
